/* ActivityViewRenderer.js */

"use strict";
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const BaseActivityViewRender = require("../../../../lib/activity/BaseActivityViewRender");

class ActivityViewRenderer extends BaseActivityViewRender {
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    render() {
        return this._model
            .whenModelIsReady()
            .then(() => {
                if (!this._rootElem) {
                    return;
                }
                if (!this._rootElem.hasChildNodes()) {
                    this._activityGrid = new EntityGrid({
                        gridKey: this._model._gridKey,
                        columns: this._model.columnConfig,
                        pagingFeed: this._model._activityFeed,
                        showHeader: true,
                        columnOrder: [
                            "activityType",
                            "snapshot",
                            "description",
                            "createdBy",
                            "status",
                            "actions",
                        ],
                        filterComponent:
                            this._model._gameEditor.renderer._rootElem.querySelector(
                                ".ge-header-left"
                            ),
                    });
                    this._rootElem.appendChild(this._activityGrid.renderer.rootElement);
                    this._model._gameEditor.renderer._rootElem.classList.add("activity-view");
                    this._registerListeners();
                }
                this._renderGridRows();
                this._hideDownloadViewAction();
            })
            .catch((error) => {
                if (this._model) {
                    this._model.logger.warn({error});
                }
            });
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START PRIVATE RENDER METHODS            */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE RENDER METHODS              */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = ActivityViewRenderer;
